import { Dispatch } from 'redux'
import { deleteDogById } from 'state/apis/account/dogApi'
import { DogType } from 'state/types/account/accountDogType'
import { Action, ActionType } from '../../types/account/accountDogType'

export const updateDogs = (dogs: DogType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_DOGS_AND_PLANS_PENDING
    })

    dispatch({
      type: ActionType.UPDATE_DOGS,
      payload: dogs
    })
  }
}

export const updateDogsToDelete = (dogIds: any[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_DOGS_TO_DELETE,
      payload: dogIds
    })
  }
}

export const deleteDog = (dogId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.DELETE_DOG_BY_ID_PENDING
    })

    try {
      await deleteDogById(dogId)
      dispatch({
        type: ActionType.DELETE_DOG_BY_ID_SUCCESS
      })
    } catch (_err) {
      dispatch({
        type: ActionType.DELETE_DOG_BY_ID_FAIL
      })
    }
  }
}

export const resetDogs = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET
    })
  }
}

/**
 * @deprecated call updatePlans in accountPlanAction.ts
 */
export const updatePlans = (plans: []) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PLANS,
      payload: plans
    })
  }
}

export const updatePlanRadio = (planRadio: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PLAN_RADIO,
      payload: planRadio
    })
  }
}
